import { NgModule } from '@angular/core';
import { FuseScrollResetDirective } from './scroll-reset.directive';

@NgModule({
  declarations: [FuseScrollResetDirective],
  exports: [FuseScrollResetDirective],
})
export class FuseScrollResetModule {}
